import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { GetFeatureIntroViewedResponse } from './interfaces';

@Injectable()
export class UserFeatureApi {
  #http = inject(HttpClient);

  public getFeatureIntroViewed(key: string) {
    return this.#http.get<GetFeatureIntroViewedResponse>(`user/feature/intro/${key}`);
  }

  public setFeatureIntroViewed(key: string) {
    return this.#http.post<void>(`user/feature/intro/${key}`, {});
  }
}
